"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    addBtn: 'Add to list',
    addProductsToBag: 'Add products to bag',
    addProductsToBagSuccessMsg: 'Successfully added {0} out of {1} products.',
    addProductsToBagSuccessTitle: 'Added to bag',
    backBtn: 'Back',
    cancel: 'Cancel',
    clearSearchField: 'Clear search field',
    closeAddProductsToBagSuccessDialog: 'Continue shopping',
    copyToClipboardBtn: 'Copy',
    copyToClipboardTooltip: 'Link copied',
    createAList: 'Create a list',
    deleteIconLabel: 'Delete list?',
    deletionDialogCancelBtn: 'Keep List',
    deletionDialogOkBtn: 'Delete List',
    deletionDialogText: 'You are about to delete a list that you might have shared with others. They will no longer be able to view your recommended products.',
    deletionDialogTitle: 'Are you really sure?',
    editList: 'Edit list',
    goToBasket: 'Go to basket',
    linkHere: 'Your list link will show here when you save',
    listNameDescription: 'Add your list name here',
    listNameTitle: 'List name',
    maxListDlgBackBtn: 'Back',
    maxPrivateDlgSaveBtn: 'Save as Public',
    maxPrivateDlgText: 'You can create a maximum of {maxNumber} private lists. But that’s ok, you can still save this list as public (this list will be displayed on Favourite Products page).',
    maxPrivateDlgTitle: 'You have reached the maximum number of private lists',
    maxPublicDlgSaveBtn: 'Save as Private',
    maxPublicDlgText: 'You can create a maximum of {maxNumber} public lists. But that’s ok, you can still save this list as private (not displayed on Favourite Products page).',
    maxPublicDlgTitle: 'You have reached the maximum number of public lists',
    personalBeautyStoreLink: 'Manage my beauty store',
    personalProductsListDetailTitle: 'Products recommended to you by {FirstName} {LastName}',
    privateSwitchLabel: 'Display on Recommended Products page?',
    privateSwitchTooltipText: 'Only people with the link will reach this page and will not be featured on the Recommended Page.',
    privateSwitchTooltipTitle: 'New! Now you can have Private Lists.',
    productListDetailDescription: 'This is the right place for managing your Personal Product List. You can add your favorite products to the grid below.',
    productListDetailPageTitle: 'Personal Product List',
    productListOverviewEmptyListMessage: 'You have no lists at the moment',
    productListOverviewPageDescription: 'Create up to {maxNumber} personalized lists of products to share with your customers. Simple and effective.',
    productListOverviewPageTitle: 'Personal Product List(s)',
    productNumber: '{products} products',
    saveList: 'Save list',
    saveListBtn: 'Save',
    searchBtn: 'Search',
    searchDefaultText: 'Paste or type in product ID',
    searchDialogLinkName: 'Browse products on webpage',
    searchDialogName: 'Add Product',
    sharingLinkButtonDescription: 'Share your list by copying the link below. By sharing the product list, anyone shopping via it will be part of your network.',
    sorryMsgText: "The product ID you are looking for doesn't seem to exist. Please give it another try.",
    sorryMsgTitle: 'We are sorry!',
    youDontHaveAnyList: 'You don’t have any lists yet.',
    yourList: 'Your list'
};
const translationsNamespace = exports.translationsNamespace = 'personal-product-list-spa';
